import { ComponentType, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import dynamic from 'next/dynamic';
import { AgeVerificationType } from 'src/apis/dto/DTOAgeVerificationStatus';
import { ageVerificationUniqueIdAtom } from 'src/components/AgeVerification/shared/context';
import { useAgeVerificationStatusQuery } from 'src/hooks/useAgeVerificationQuery';
const IdvFlow = dynamic(() => import('src/components/AgeVerification/idv'), {
  ssr: false
});
export type AgeVerificationVendorComponent = ComponentType<{
  onComplete: () => void;
}>;
interface Props {
  VendorComponent: AgeVerificationVendorComponent;
  onComplete: () => void;
}

/**
 * 나이인증 벤더(Yoti/FaceTec/OSA) 위에서, 항상 살아있는 /status 구독을 통해
 * type이 ID_VERIFICATION으로 바뀌는 순간 벤더 컴포넌트를 신분증 인증(IdvFlow)으로
 * 교체한다. 벤더 컴포넌트 쪽 코드는 이 교체를 전혀 알 필요가 없다.
 */
const AgeVerificationRouter = ({
  VendorComponent,
  onComplete
}: Props) => {
  const {
    data,
    isLoading
  } = useAgeVerificationStatusQuery();
  const setUniqueId = useSetAtom(ageVerificationUniqueIdAtom);

  // 이벤트로그 unique_id는 "인증 시도 전체(벤더 화면 → IDV 재시도까지)"를 연결하는 key.
  // VendorComponent ↔ IdvFlow 전환 시에도 값이 살아있어야 하므로 atom에 보관하고,
  // 이 Router가 unmount(= 인증 세션 종료)될 때만 다음 세션을 위해 초기화한다.
  useEffect(() => {
    return () => setUniqueId(null);
  }, [setUniqueId]);
  if (isLoading) return null;
  const type = data?.data.result.type;
  if (type === AgeVerificationType.IdVerification) {
    return <IdvFlow onComplete={onComplete} />;
  }
  return <VendorComponent onComplete={onComplete} data-sentry-element="VendorComponent" data-sentry-component="AgeVerificationRouter" data-sentry-source-file="AgeVerificationRouter.tsx" />;
};
export default AgeVerificationRouter;